<form>
	<!-- Modal Header -->
	<div class="modal-header">
		<h4 class="modal-title">{{ isEdit ? 'Edit' : 'Add' }} Finance Account</h4>
		<button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="close()"></button>
	</div>

	<div class="modal-body">
		<form method="post" class="d-flex flex-column gap-3 mt-2">
			<div class="form-floating">
				<input type="text" class="form-control" id="code" name="code" placeholder="Code" [(ngModel)]="fa().Code" required />
				<label for="code">Code</label>
			</div>
			<div class="form-floating">
				<select class="form-select" id="bank" name="bank" [ngModel]="isOtherBank() ? 'Other' : fa().Bank" (ngModelChange)="bankChanged($event)" required>
				@for (b of BANK_CONFIG; track b.code) {
           <option [value]="b.bankName">{{ b.bankName }}</option>
         }
					<option value="Other">Other</option>
				</select>
				<label for="bank">Bank</label>
			</div>
			@if (isOtherBank()) {
				<div class="form-floating">
					<input type="text" class="form-control" id="otherBank" name="otherBank" placeholder="Other Bank" [(ngModel)]="fa().Bank" required />
					<label for="otherBank">Other Bank</label>
				</div>
			}
			<div class="form-floating">
				<input type="text" class="form-control" id="accNumber" name="accNumber" placeholder="Account Number" [(ngModel)]="fa().AccNumber" required />
				<label for="accNumber">Account Number</label>
			</div>
			<div class="form-floating">
				<input type="text" class="form-control" id="description" name="description" placeholder="Description" [(ngModel)]="fa().Description" required />
				<label for="description">Description</label>
			</div>
			<div class="form-floating">
				<input type="text" class="form-control" id="directors" name="directors" placeholder="Directors" [(ngModel)]="fa().Directors" required />
				<label for="directors">Directors</label>
			</div>
		</form>
	</div>
	<div class="modal-footer">
		<button class="btn btn-light" type="button" (click)="reset()">Reset</button>
		<button class="btn btn-primary" type="button" (click)="submit()" [disabled]="disabledSubmit">Submit</button>
	</div>
</form>
